import api from "../../index";

export const GetFolderListApi = () => api.post('filefolderlist');
export const GetBookKeepingApi = () => api.post('get-bookkeeping-list');
export const GetBookKeepingQuestionListApi = (data) => api.post('bookkeeping-repeat-question-list', data);
export const GetBookKeepingDocumentApi = (data) => api.post('get-bookkeeping-document', data);
export const GetBookKeepingByIdApi = (data) => api.post('bookkeeping-file-data', data);
export const GetChildFolderListApi = (data) => api.post('viewfilefolder', data);
export const DeleteFileFolderApi = (data) => api.post('deletefilefolder', data);
export const UploadFileFolderApi = (data, headers) => api.post('uploadfilefolder', data, headers);
export const GetTrashFolderListApi = () => api.post('trashdocumentslist');
export const OpenTrashFolderApi = (data) => api.post('viewtrashfilefolder', data);
export const PermanentDeleteFileFolderApi = (data) => api.post('permanentdeletefilefolder', data);
export const RestorefilefolderApi = (data) => api.post('restorefilefolder', data);
export const MoveFileFolderApi = (data) => api.post('movefilefolder', data);
export const DownloadFileFolderApi = (data, headers) => api.post('download-file-folder', data, headers);
export const DownloadMultipleFileFolderApi = (data, headers) => api.post('download-multiple-file-folder', data, headers);
export const RenameFileFolderApi = (data) => api.post('renamefilefolder', data);
